export default {
    loaded: false,
    googleAnalyticsID: 'UA-120665843-2'
}



// WEBPACK FOOTER //
// ./src/data/config.js